<template>
    <div class="product-category__carousel py-4">
        <h4 v-if="title != ''" class="u-color-blue-shade-1 mb-2">{{title}}</h4>
        <div :id="id" class="carousel--products owl-carousel u-animate__fade-up">
                <ProductCard      
                    v-for="product in items"            
                    v-bind="product" 
                    :key="product.id"
                />
                <a v-if="showAllLink" class="card--product" :href="url" :aria-label="title">
                    <h4 class="card__title">{{title}}</h4>
                </a>
        </div>
    </div>
</template>
<script>
import ProductCard from './ProductCard.vue'
export default {
    data() {
        return {
            loading : true
        }
    },
    props : {
        id : [String, Number],
        url : {
          type: String,
          default: ''
        },
        showAllLink : {
            type : Boolean,
            default : true
        },
        title: String,
        products: [Array, String],
    },
    components : {
        ProductCard
    },
    computed: {
        items() {
            if (Array.isArray(this.products)) {
                return this.products
            } else if (typeof this.products == 'string') {
                return JSON.parse(this.products)
            } else {
                return []
            }
        }
    },
    mounted() {
        this.loading = false;
        this.$nextTick(()=>{
          const navText = TG.vue.navigation || {next: "Next", prev: "Previous"}
            jQuery(this.$el).find(`#${this.id}`).owlCarousel({
                margin : 15,
                nav : true,
                navText : [
                    `<span aria-hidden="true" role="navigation" aria-label="${navText.prev}"></span>`,
                    `<span aria-hidden="true" role="navigation" aria-label="${navText.next}"></span>`
                ],
                responsive : {
                    0 : {
                        items : 1,
                        stagePadding : 28
                    },
                    768 : {
                        items : 2
                    },
                    992 : {
                        items : 3
                    },
                    1200 : {
                        items : 4
                    }
                }
            });
        })
    }   
}
</script>